export default __webpack_public_path__ + "static/media/SLK.4d5da7b9.jpeg";